import React, { useEffect, useState } from 'react'
import DashboardLeftMenu from './DashboardLeftMenu'
import DashboardHeader from '../Header/DashboardHeader'
import DashboardFooter from '../Footer/AdminFooter'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
// import WebhookModal from './WebhookModal'
import { CAMPAIGN_CONTACT_LIST_API, WHATSAPP_TEMPLATE_LIST } from '../../constants/ServiceConstants'
import Axios from '../../axios/Axios'
import { getSMSTemplateList, HOST_URL, NODE_HOST_URL_v1, RCSAPI } from './api/Api'
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min'
import Select from "react-select";

const Workflow = () => {
    const history = useHistory();
    const lStorage = JSON.parse(localStorage.getItem("login"));
    const user_id = lStorage.user.userId;
    const token = lStorage.token;
    const userType = lStorage.user.isAdmin

    const [openCreateWorkflow, setOpenCreateWorkFlow] = useState(false);
    const [showButton, setShowButton] = useState(true);
    const [workflowName, setWorkflowName] = useState('');
    const [searchApp, setSearchApp] = useState('');
    const [triggerEvent, setTriggerEvent] = useState("");
    const [showmore, setShowmore] = useState(false);
    const [webhookURL, setWebhookURL] = useState("");
    const [apps, setApps] = useState({
        Zoho_CRM: false,
        Hubspots: false,
        Cretio: false,
        Supabase: false,
        Auth0_by_okta: false,
        Gorgias: false,
        vtiger_CRM: false,
        Zendesk: false,
        Microsoft_Azure: false,
        Bigcommerce: false,
        voucherify: false,
        Parceltracker: false,
        Odoo_CRM: false,
        Magento_Adobe: false,
        Freshworks: false,
        Monday_CRM: false,
        Stripe: false,
        Facebook: false,
    });
    const [showModal, setShowModal] = useState(false);
    const [selectedFields, setSelectedFields] = useState([]);
    const [channel, setChannel] = useState("");
    const [whatsapptemplateSelect, setWhatsappTemplateSelect] = useState('');
    const [smstemplateSelect, setSmsTemplateSelect] = useState('');
    const [rcstemplateSelect, setRcsTemplateSelect] = useState('');
    const [voicetemplateSelect, setVoiceTemplateSelect] = useState('');
    const [showNextstep, setShowNextstep] = useState(false)
    const [whatsappTemplateList, setWhatsappTemplateList] = useState([]);
    const [smsTemplateList, setSmsTemplateList] = useState([]);
    const [rcsTemplateList, setRcsTemplateList] = useState([]);
    const [voiceTemplateList, setVoiceTemplateList] = useState([]);
    const [whatsappVariable, setWhatsappVariable] = useState('');
    const [smsVariable, setSmsVariable] = useState('');
    const [rcsVariable, setRcsVariable] = useState('');
    const [voiceVariable, setVoiceVariable] = useState('');
    const [selectedWhatsappvariable, setSelectedWhatsappvariable] = useState({});
    const [selectedSmsvariable, setSelectedSmsvariable] = useState({});
    const [selectedRcsvariable, setSelectedRcsvariable] = useState({});
    const [generateWebhook, setGenerateWebhook] = useState(false);
    const [triggerEventAction, setTriggerEventAction] = useState(false);
    const [showUrl, setShowUrl] = useState(false);
    const [platformData, setPlatformsData] = useState([]);
    const [PlatformEventData, setPlatformsEventData] = useState([]);
    const [eventList, setEventList] = useState([]);
    const [isData, setIsData] = useState(false);
    const [contactListData, setContactListData] = useState([]);
    const [contactList, setContactList] = useState("");
    const [authkey, setAuthkey] = useState("");
    const [platformId, setPlatFormId] = useState("");
    const [sampleData, setSampleData] = useState({});
    const [allKeys, setAllKeys] = useState([]);
    const [fields, setFields] = useState({
        mobile: "",
        email: ""
    });
    const [editPlatformData, setEditPlatformData] = useState([]);
    const [error, setError] = useState({
        errorStatus: false,
        bgColor: "",
        errorMessage: "",
    });
    const [showgenerateUrl, setShowgenerateUrl] = useState(false);
    const [disableButton, setDisableButton] = useState(false);
    const { id } = useParams();

    const handleFieldChange = (e) => {
        setFields({ ...fields, [e.target.name]: e.target.value });
    }

    // Recursive function
    // 🔥 Function: Returns only keys that have non-empty values
    const getAllKeysWithValues = (obj, parentKey = "", result = []) => {
        for (let key in obj) {
            if (!obj.hasOwnProperty(key)) continue;

            const newKey = parentKey ? `${parentKey}_${key}` : key;
            const value = obj[key];

            // ❌ Skip null / undefined / empty string
            if (value === null || value === undefined || value === "") continue;

            // ❌ Skip empty array
            if (Array.isArray(value) && value.length === 0) continue;

            // ❌ Skip empty object
            if (typeof value === "object" && !Array.isArray(value) && Object.keys(value).length === 0) continue;

            // ✅ Value exists → push key
            result.push(newKey);

            // 🔁 Recursive: Object
            if (typeof value === "object" && value !== null && !Array.isArray(value)) {
                getAllKeysWithValues(value, newKey, result);
            }

            // 🔁 Recursive: Array of objects
            if (Array.isArray(value)) {
                value.forEach((item, index) => {
                    if (typeof item === "object" && item !== null) {
                        getAllKeysWithValues(item, `${newKey}_${index}`, result);
                    }
                });
            }
        }
        return result;
    };


    useEffect(() => {
        if (sampleData && Object.keys(sampleData).length > 0) {
            const keys = getAllKeysWithValues(sampleData);
            setAllKeys(keys);
        }
    }, [sampleData]);


    useEffect(() => {
        getWhatsaAppTemplateList();
        fetchTemplateDetails();
        getRcsTemplate();
        VoicetemplateList();
    }, []);

    useEffect(() => {
        if (id && isData && editPlatformData.length && PlatformEventData.length) {
            retrieveData();
        }
    }, [id, isData, editPlatformData, PlatformEventData]);

    useEffect(() => {
        PlatformEventList();
        // PlatformList();
        getWhatsaAppNumberList();
        AuthkeyData();
    }, [])

    const retrieveData = async () => {
        // if(platformData.length === 0){
        //     return 
        // }
        try {
            const paramData = {
                user_id: user_id,
                method: "capture_response_byid",
                token: token,
                id: id
            };

            const { data } = await Axios.post(
                `${HOST_URL}/webhook_reciever.php`,
                paramData
            );

            if (!data?.success) return;

            // 🔗 Webhook URL
            const Editurl = `https://console.authkey.io/restapi/data_receiver.php?list_id=${data.data.list_id}&authkey=${authkey}&event_id=${data.data.event_id}&platform_id=${data.data.platform}`;

            // 🧾 Parse JSON safely
            const sampleData = JSON.parse(data.data.sample_data);
            const selectedSampleData = JSON.parse(
                data.data.selected_data.replace(/'/g, '"')
            );

            // 🔍 Find platform (use find, not filter)
            let selectedPlatform = editPlatformData.find(
                item => item.plat_name?.toLowerCase() === data.data.platform_name?.toLowerCase()
            );

            // 🎯 Filter events based on platform id
            let filterDataEdit = [];
            if (selectedPlatform) {
                filterDataEdit = PlatformEventData.filter(
                    event => event.plat_id === selectedPlatform.id
                );
            }

            // 🔑 Extract all keys from sample data
            const allKeys = Object.keys(sampleData);

            // ✅ Set states
            setEventList(filterDataEdit);
            setWorkflowName(data.data.name)
            setTriggerEvent(data.data.event_id);
            setContactList(data.data.list_id);
            setPlatFormId(data.data.platform);
            setWebhookURL(Editurl);
            setShowNextstep(true);
            setAllKeys(allKeys);
            setSelectedFields(selectedSampleData);
            setFields({
                mobile: data.data.mobile_key,
                email: data.data.email_key
            });

        } catch (error) {
            console.error("Error in retrieveData:", error);
        }
    };


    const AuthkeyData = async () => {
        let paramData = {
            user_id: user_id,
            method: "retrieve",
            token: token,
        }
        let { data } = await Axios.post(`${HOST_URL}/profile.php`, paramData)
        if (data.success) {
            setAuthkey(data.data[0].authkey)
        }
    }

    const copyToClipboard = () => {
        navigator.clipboard.writeText(webhookURL);
        alert("Copied to clipboard!");
    };

    const handleWhatsappTemplateChange = (e) => {
        const selectedWhatsappId = e.target.value;

        const selectedTemplate = whatsappTemplateList.find(
            t => String(t.id) === selectedWhatsappId
        );

        if (!selectedTemplate) return;

        // Source string (priority wise)
        const sourceText =
            // selectedTemplate.temp_attribute ||
            // selectedTemplate.temp_body ||
            selectedTemplate.full_content ||
            "";

            // console.log(sourceText);
            

        // Extract {{variable}} pattern
        const matches = sourceText.match(/{{(.*?)}}/g) || [];

        // Clean variables
        const variables = matches.map(v =>
            v.replace("{{", "").replace("}}", "")
        );

        setWhatsappVariable(variables);   // ["1"]
        setWhatsappTemplateSelect(selectedTemplate);
    };

    // console.log(whatsapptemplateSelect);
    
    




    const handleSmsTemplateChange = (e) => {
        const selectedSmsId = e.target.value;

        const selectedTemplate = smsTemplateList.find(
            t => String(t.id) === selectedSmsId
        );

        if (!selectedTemplate) return;

        // Extract variables from content
        const content = selectedTemplate.content || "";

        const variableMatches = content.match(/{#(.*?)#}/g) || [];

        const variables = variableMatches.map(v =>
            v.replace("{#", "").replace("#}", "")
        );

        setSmsVariable(variables);   // ["name", "user"]
        setSmsTemplateSelect(selectedTemplate);
    };

    const handleRcsTemplateChange = (e) => {
        const selectedRcsId = e.target.value;

        const selectedTemplate = rcsTemplateList.find((t) => {
            return String(t._id) === selectedRcsId;
        });
        let Variable = selectedTemplate?.parameters
        setRcsVariable(Variable)

        setRcsTemplateSelect(selectedTemplate);
    };

    const handleVoiceTemplateChange = (e) => {
        const selectedVoiceId = e.target.value;

        const selectedTemplate = voiceTemplateList.find((t) => {
            return String(t.id) === selectedVoiceId;
        });
        let Variable = JSON.parse(selectedTemplate?.temp_attribute)
        setVoiceVariable(Variable)

        setVoiceTemplateSelect(selectedTemplate);
    };

    const PlatformList = async (dataList) => {
        let paramData = {
            method: "ListPlatform",
            user_id: user_id,
            user_type: userType,
            token: token
        };

        let { data } = await Axios.post(`${NODE_HOST_URL_v1}/admin/DataReceiver`, paramData);

        if (data.success) {



            // SAFE way to access event data
            const ids = new Set((dataList || []).map(item => item.plat_id));

            const common = data.data.filter(item => ids.has(item.id));
            setPlatformsData(common);
            setEditPlatformData(data.data)

        }
    };






    const PlatformEventList = async () => {
        let paramData = {
            method: "FetchEvent",
            user_id: user_id,
            user_type: userType,
            token: token
        }
        let { data } = await Axios.post(`${NODE_HOST_URL_v1}/admin/DataReceiver`, paramData)
        if (data.success) {
            setPlatformsEventData(data.data);
            PlatformList(data.data)
            setIsData(true)
        }
    }

    const handlePlatformData = (id) => {
        let filterData = PlatformEventData.filter(x => x.plat_id === id);
        setEventList(filterData);
        setPlatFormId(id)
    }

    const getWhatsaAppTemplateList = async () => {
        try {
            const { data } = await Axios.post(WHATSAPP_TEMPLATE_LIST, {
                token: token,
                user_id: user_id,
                method: "retrieve",
            });

            if (data.success === true) {
                setWhatsappTemplateList(data.data)
            }
        } catch (err) {
            console.log(err);
        }
    };

    const fetchTemplateDetails = () => {
        const paramData = {
            user_id: user_id,
            method: "retrieve",
            id: null,
            token: token,
        };

        getSMSTemplateList(paramData)
            .then((response) => {
                if (response.data.success === true) {
                    setSmsTemplateList(response.data.data);
                }
            })
            .catch((error) => {
                console.error("Error fetching SMS template list:", error);
            });
    };

    const getRcsTemplate = async () => {
        try {
            let paylod = {
                user_id: user_id,
                token: token,
                method: "retrieve_temp",
            };
            let { data } = await RCSAPI(paylod);
            if (data.success) {
                setRcsTemplateList(data.data);
            }
        } catch (error) {
            console.log(error.errormessage)
        }
    };

    const VoicetemplateList = async () => {
        let paramData = {
            user_id: user_id,
            method: "retrieve",
            token: token
        }
        let { data } = await Axios.post(`${HOST_URL}/voice_template.php`, paramData)
        if (data.success === true) {
            setVoiceTemplateList(data.data)
        }
    }

    const handleCheckboxChange = (field) => {
        setSelectedFields(prev =>
            prev.includes(field)
                ? prev.filter(f => f !== field)
                : [...prev, field]
        );
    };

    const openNextstep = () => {
        setShowNextstep(true)
        setShowModal(false)
    }

    const fieldOptions = [
        'form_id',
        'ad_name',
        'field_data.full_name',
        'field_data.email',
        'field_data.phone_number',
        'field_data.company_name',
        'field_data.address',
        'field_data.zip_code',
        'field_data.country',
    ];

    // Conditional background color
    const backgroundColor = openCreateWorkflow ? '#f4f7fdff' : 'white';

    const PreviousStep = () => {
        history.push("/dashboard/workflow-list");
    }

    const getWhatsaAppNumberList = async () => {
        try {
            const { data } = await Axios.post(CAMPAIGN_CONTACT_LIST_API, {
                token: token,
                user_id: user_id,
                method: "retrieve",
            });
            if (data.success === true) {
                let filterData = data.data.filter(x => (x.status === 1 && x.list_type === "integration"))
                setContactListData(filterData);
                // console.log(filterData);
                
                // this.setState({ ContactListData: filterData, setIsLoading: false });
            }
            //   else {
            //     this.setState({ errorMessage: data.message, isError: true, messageType: 'alert-danger', setIsLoading: false });
            //   }
        } catch (err) {
            console.log(err);
        }
    };

    const NewContactList = () => {
        history.push("/dashboard/create-contact-list");
    }

    const GenerateUrl = () => {
        let url = `https://console.authkey.io/restapi/data_receiver.php?list_id=${contactList}&authkey=${authkey}&event_id=${triggerEvent}&platform_id=${platformId}`
        setWebhookURL(url);
        setShowUrl(true)
    }

    const CaptureResponse = async () => {
        let paramData = {
            user_id: user_id,
            method: "capture_response",
            token: token,
            list_id: contactList,
            platform_id: platformId,
            event_id: triggerEvent
        }
        let { data } = await Axios.post(`${HOST_URL}/webhook_reciever.php`, paramData);
        if (data.success) {
            setSampleData(data.sample_data);
            setShowNextstep(true)
        }
    }

    const handleContactListChange = (e) => {
        setContactList(e.target.value)
        CheckUpdateStatus(e.target.value);
        setError({ errorStatus: false })
    }

    const CheckUpdateStatus = async (listid) => {
        let paramData = {
            user_id: user_id,
            method: "check_exixting_webhook",
            token: token,
            list_id: listid,
            platform_id: platformId,
            event_id: triggerEvent,
        }
        let { data } = await Axios.post(`${HOST_URL}/webhook_reciever.php`, paramData)
        if (data.success) {
            // console.log(data);
            setShowgenerateUrl(true)
        }
        else {
            setError({
                errorStatus: true,
                bgColor: "alert alert-danger",
                errorMessage: `Workflow for this contact list is already exist with name ${data.name}`,
            });
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    }

    const handleWorkflowname = (e) => {
        setWorkflowName(e.target.value);
        setError({ errorStatus: false })
    }

    const SaveWebhook = async () => {
        if (workflowName === undefined || workflowName === "") {
            setError({
                errorStatus: true,
                bgColor: "alert alert-danger",
                errorMessage: `Please Enter Workflow name`,
            });
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            return
        }
        setDisableButton(true)
        let paramData = {
            user_id: user_id,
            method: "update",
            token: token,
            name: workflowName,
            list_id: contactList,
            platform_id: platformId,
            event_id: triggerEvent,
            selected_data: selectedFields,
            mobile_key: fields.mobile,
            email_key: fields.email,
            whatsapp: {[whatsapptemplateSelect.id] : selectedWhatsappvariable},
            sms: {[smstemplateSelect.id] : selectedSmsvariable},
            rcs: {[rcstemplateSelect.bot_id] : selectedRcsvariable},
            allow_trigger : triggerEventAction ? 1 : 0
        };

        let { data } = await Axios.post(`${HOST_URL}/webhook_reciever.php`, paramData);

        if (data.success) {
            setError({
                errorStatus: true,
                bgColor: "alert alert-success",
                errorMessage: data.message,
            });
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            history.push(`/dashboard/workflow-list`);
            setDisableButton(true);
        }
        else {
            setError({
                errorStatus: true,
                bgColor: "alert alert-danger",
                errorMessage: data.message,
            });
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
            setDisableButton(true);
        }
    };


    const isAnyAppEnabled = Object.values(apps).some(value => value);
    const channelOptions = [
        { value: "whatsapp", label: "Whatsapp" },
        { value: "sms", label: "SMS" },
        { value: "rcs", label: "RCS" },
        // { value: "voice", label: "Voice" },
    ];

    const channelHandler = (selectedOptions) => {
        setChannel(selectedOptions);
        // agar sirf values chahiye:
        // setChannel(selectedOptions.map(item => item.value));
    };

    const handleWhatsappVariableChange = (key, value) => {
        setSelectedWhatsappvariable(prev => ({
            ...prev,
            [key]: value
        }));
    };

    // console.log("whatsapp:" , selectedWhatsappvariable);
    

    const handleSmsVariableChange = (key, value) => {
        setSelectedSmsvariable(prev => ({
            ...prev,
            [key]: value
        }));
    };

    // console.log("sms:" ,selectedSmsvariable);
    

    const handleRcsVariableChange = (key, value) => {
        setSelectedRcsvariable(prev => ({
            ...prev,
            [key]: value
        }));
    };

    // console.log("rcs:",selectedRcsvariable);
    
    return (
        <div className="wrapper">
            <DashboardLeftMenu />
            <div
                className="main"
                style={{
                    backgroundColor: backgroundColor,
                    minHeight: '100vh',
                    transition: 'background-color 0.3s ease'
                }}
            >
                <DashboardHeader />
                <main className="content">
                    <div className="container-fluid p-0">
                        <div className="row mb-2 mb-xl-3">
                            <div className="d-flex justify-content-end">
                                {showButton &&
                                    <button
                                        type="button"
                                        onClick={PreviousStep}
                                        className="btn btn-secondary"
                                    >
                                        Go Back
                                    </button>
                                }
                            </div>
                        </div>
                        <div className="d-flex justify-content-center my-4">
                            <div style={{ width: "100%", maxWidth: "700px" }}>
                                {error.errorStatus && (
                                    <div className={error.bgColor} role="alert">
                                        {/* <button
                                            type="button"
                                            className="close"
                                            data-dismiss="alert"
                                            aria-label="Close"
                                        >
                                            <span aria-hidden="true">×</span>
                                        </button> */}
                                        <div>{error.errorMessage}</div>
                                    </div>
                                )}
                                {/* Label outside the card but left-aligned with card content */}
                                <span className="text-muted fw-semibold mb-2 d-block">
                                    <b>WORKFLOW NAME</b>
                                </span>

                                {/* Card content */}
                                <div
                                    className="card"
                                    style={{
                                        backgroundColor: "white",
                                        padding: "1.5rem"
                                    }}
                                >
                                    <div className="row">
                                        <div className="col-12">
                                            <input
                                                type="text"
                                                className="form-control"
                                                style={{ padding: "10px 12px", borderRadius: "6px" }}
                                                placeholder="Enter workflow name"
                                                value={workflowName}
                                                onChange={handleWorkflowname}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-center my-4">
                            <div style={{ width: "100%", maxWidth: "700px" }}>
                                {/* Label outside the card but left-aligned with card content */}
                                <span className="text-muted fw-semibold mb-2 d-block">
                                    <b>TRIGGER: WHEN THIS HAPPENS...</b>
                                </span>

                                {/* Card content */}
                                <div
                                    className="card"
                                    style={{
                                        backgroundColor: "white",
                                        padding: "1.5rem"
                                    }}
                                >
                                    {/* Input Field */}
                                    <div className="row mb-3">
                                        <div className="col-12">
                                            <label><b>Select App</b></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                style={{ padding: "10px 12px", borderRadius: "6px" }}
                                                placeholder="Search for an app..."
                                                value={searchApp}
                                                onChange={(e) => setSearchApp(e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    {/* App Cards Grid */}
                                    <div className="row g-3">
                                        {platformData.map((x) => {
                                            return (
                                                <div className="col-6 col-md-3 mt-2" onClick={() => handlePlatformData(x.id)} style={{ cursor: "pointer" }}>
                                                    <div style={{ backgroundColor: apps.Microsoft_Azure ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                        <img
                                                            className="img-fluid"
                                                            style={{ maxHeight: "50px", objectFit: "contain" }}
                                                            src={x.plat_logo}
                                                            alt={x.plat_name}
                                                        />
                                                        <p style={{ fontSize: "12px" }} className="mt-2 mb-0">{x.plat_name}</p>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        {/* 
                                                <div className="col-6 col-md-3" onClick={handleZohoCrm} style={{ cursor: "pointer" }}>
                                                    <div style={{ backgroundColor: apps.Zoho_CRM ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                        <img
                                                            className="img-fluid"
                                                            style={{ maxHeight: "50px", objectFit: "contain" }}
                                                            src="https://media.licdn.com/dms/image/v2/D5633AQF23elkUZXveA/productpage-image_1128_635/productpage-image_1128_635/0/1690388693486/bilzy_tech_zoho_crm_image?e=1760176800&v=beta&t=SDiiL1adY7a2ZA2S3hWH6VtefW0cVtRl36wr0JqzGVY"
                                                            alt="App Logo"
                                                        />
                                                        <p className="mt-2 mb-0">ZOHO CRM</p>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-3" onClick={handleHubspots} style={{ cursor: "pointer" }}>
                                                    <div style={{ backgroundColor: apps.Hubspots ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                        <img
                                                            className="img-fluid"
                                                            style={{ maxHeight: "50px", objectFit: "contain" }}
                                                            src="https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/168_Hubspot_logo_logos-512.png"
                                                            alt="App Logo"
                                                        />
                                                        <p className="mt-2 mb-0">Hubshot</p>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-3" onClick={handleCretio} style={{ cursor: "pointer" }}>
                                                    <div style={{ backgroundColor: apps.Cretio ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                        <img
                                                            className="img-fluid"
                                                            style={{ maxHeight: "50px", objectFit: "contain" }}
                                                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQNdcj2AFaExHKxoRUggXpAcoQhA8ntMFYQwQ&s"
                                                            alt="App Logo"
                                                        />
                                                        <p className="mt-2 mb-0">Cretio</p>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-3 mt-2" onClick={handleSupabase} style={{ cursor: "pointer" }}>
                                                    <div style={{ backgroundColor: apps.Supabase ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                        <img
                                                            className="img-fluid"
                                                            style={{ maxHeight: "50px", objectFit: "contain" }}
                                                            src="https://logo.svgcdn.com/d/supabase-original-8x.png"
                                                            alt="App Logo"
                                                        />
                                                        <p className="mt-2 mb-0">Supabase</p>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-3 mt-2" onClick={handleAuth} style={{ cursor: "pointer" }}>
                                                    <div style={{ backgroundColor: apps.Auth0_by_okta ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                        <img
                                                            className="img-fluid"
                                                            style={{ maxHeight: "50px", objectFit: "contain" }}
                                                            src="https://pages.okta.com/rs/855-QAH-699/images/email-main-template_auth0-by-okta-logo_black_279x127_3x.png"
                                                            alt="App Logo"
                                                        />
                                                        <p className="mt-2 mb-0">Auth0 by okta</p>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-3 mt-2" onClick={handlevtigerCRM} style={{ cursor: "pointer" }}>
                                                    <div style={{ backgroundColor: apps.vtiger_CRM ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                        <img
                                                            className="img-fluid"
                                                            style={{ maxHeight: "50px", objectFit: "contain" }}
                                                            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQxmfdpifHY1UzIQJPEiKDWz6iyq5Hu-iHnHA&s"
                                                            alt="App Logo"
                                                        />
                                                        <p className="mt-2 mb-0">vtiger CRM</p>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-md-3 mt-2" onClick={handleFacebook} style={{ cursor: "pointer" }}>
                                                    <div style={{ backgroundColor: apps.Facebook ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                        <img
                                                            className="img-fluid"
                                                            style={{ maxHeight: "50px", objectFit: "contain" }}
                                                            src="https://static.vecteezy.com/system/resources/previews/018/930/698/non_2x/facebook-logo-facebook-icon-transparent-free-png.png"
                                                            alt="App Logo"
                                                        />
                                                        <p className="mt-2 mb-0">Facebook</p>
                                                    </div>
                                                </div> */}

                                        {/* {showmore &&
                                                    <>
                                                        <div className="col-6 col-md-3 mt-2" onClick={handleGorgias} style={{ cursor: "pointer" }}>
                                                            <div style={{ backgroundColor: apps.Gorgias ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                                <img
                                                                    className="img-fluid"
                                                                    style={{ maxHeight: "50px", objectFit: "contain" }}
                                                                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIbpFtQueEXI2A6pFWKogS8ojxUQOhZeMZ_Q&s"
                                                                    alt="App Logo"
                                                                />
                                                                <p className="mt-2 mb-0">Gorgias</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-6 col-md-3 mt-2" onClick={handleZendesk} style={{ cursor: "pointer" }}>
                                                            <div style={{ backgroundColor: apps.Zendesk ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                                <img
                                                                    className="img-fluid"
                                                                    style={{ maxHeight: "50px", objectFit: "contain" }}
                                                                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT-kAC6Ysu_TbwJm1RObbbndXYYwgOE9L0ldA&s"
                                                                    alt="App Logo"
                                                                />
                                                                <p className="mt-2 mb-0">Zendesk</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-6 col-md-3 mt-2" onClick={handleBigcommerce} style={{ cursor: "pointer" }}>
                                                            <div style={{ backgroundColor: apps.Bigcommerce ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                                <img
                                                                    className="img-fluid"
                                                                    style={{ maxHeight: "50px", objectFit: "contain" }}
                                                                    src="https://img.icons8.com/?size=512&id=Nmy7xin7TGr7&format=png"
                                                                    alt="App Logo"
                                                                />
                                                                <p style={{ fontSize: "12px" }} className="mt-2 mb-0">Big Commerce</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-6 col-md-3 mt-2" onClick={handlevoucherify} style={{ cursor: "pointer" }}>
                                                            <div style={{ backgroundColor: apps.voucherify ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                                <img
                                                                    className="img-fluid"
                                                                    style={{ maxHeight: "50px", objectFit: "contain" }}
                                                                    src="https://gdm-catalog-fmapi-prod.imgix.net/ProductLogo/780a1114-f852-4ca1-b39a-b61730924af6.png"
                                                                    alt="App Logo"
                                                                />
                                                                <p className="mt-2 mb-0">Voucherify</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-6 col-md-3 mt-2" onClick={handleParceltracker} style={{ cursor: "pointer" }}>
                                                            <div style={{ backgroundColor: apps.Parceltracker ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                                <img
                                                                    className="img-fluid"
                                                                    style={{ maxHeight: "50px", objectFit: "contain" }}
                                                                    src="https://png.pngtree.com/png-clipart/20230921/original/pngtree-tracking-icon-for-package-delivery-with-map-pin-vector-illustration-vector-png-image_12491173.png"
                                                                    alt="App Logo"
                                                                />
                                                                <p className="mt-2 mb-0">Parceltracker</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-6 col-md-3 mt-2" onClick={handleOdoo} style={{ cursor: "pointer" }}>
                                                            <div style={{ backgroundColor: apps.Odoo_CRM ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                                <img
                                                                    className="img-fluid"
                                                                    style={{ maxHeight: "50px", objectFit: "contain" }}
                                                                    src="https://odoocdn.com/openerp_website/static/src/img/assets/png/odoo_gold_partner_rgb.png"
                                                                    alt="App Logo"
                                                                />
                                                                <p className="mt-2 mb-0">Odoo CRM</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-6 col-md-3 mt-2" onClick={handleMagento} style={{ cursor: "pointer" }}>
                                                            <div style={{ backgroundColor: apps.Magento_Adobe ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                                <img
                                                                    className="img-fluid"
                                                                    style={{ maxHeight: "50px", objectFit: "contain" }}
                                                                    src="https://pnghdpro.com/wp-content/themes/pnghdpro/download/social-media-and-brands/magento-logo-icon.png"
                                                                    alt="App Logo"
                                                                />
                                                                <p style={{ fontSize: "12px" }} className="mt-2 mb-0">Magento Adobe</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-6 col-md-3 mt-2" onClick={handleFreshworks} style={{ cursor: "pointer" }}>
                                                            <div style={{ backgroundColor: apps.Freshworks ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                                <img
                                                                    className="img-fluid"
                                                                    style={{ maxHeight: "50px", objectFit: "contain" }}
                                                                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpJTZvvEP_bfuoiFN2I2snY3dha6lVwlPqtQ&s"
                                                                    alt="App Logo"
                                                                />
                                                                <p className="mt-2 mb-0">Freshworks</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-6 col-md-3 mt-2" onClick={handleMonday} style={{ cursor: "pointer" }}>
                                                            <div style={{ backgroundColor: apps.Monday_CRM ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                                <img
                                                                    className="img-fluid"
                                                                    style={{ maxHeight: "50px", objectFit: "contain" }}
                                                                    src="https://assets.project-management.com/uploads/2023/01/monday-CRM-logo-200x200-1.png"
                                                                    alt="App Logo"
                                                                />
                                                                <p className="mt-2 mb-0">Monday CRM</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-6 col-md-3 mt-2" onClick={handleStripe} style={{ cursor: "pointer" }}>
                                                            <div style={{ backgroundColor: apps.Stripe ? "whitesmoke" : "white" }} className="border rounded p-3 text-center shadow-sm h-100">
                                                                <img
                                                                    className="img-fluid"
                                                                    style={{ maxHeight: "50px", objectFit: "contain" }}
                                                                    src="https://logos-world.net/wp-content/uploads/2022/12/Stripe-Emblem.png"
                                                                    alt="App Logo"
                                                                />
                                                                <p className="mt-2 mb-0">Stripe</p>
                                                            </div>
                                                        </div>
                                                    </>} */}

                                        <span style={{ fontSize: "12px", cursor: "pointer" }} onClick={() => setShowmore(!showmore)} className='ml-3'>{showmore ? <span>show less...</span> : <span>show more...</span>}</span>

                                        {/* Add more col-3 cards as needed */}
                                    </div>

                                    {eventList.length > 0 &&
                                        <div className="row mb-3 mt-2">
                                            <div className="col-12">
                                                <label><b>Select Event</b></label>
                                                <select className="form-control" name='triggerevent' value={triggerEvent} onChange={(e) => setTriggerEvent(e.target.value)}>
                                                    <option value="new_product">--Choose an Event--</option>
                                                    {eventList.map((x) => {
                                                        return (
                                                            <option value={x.id}>{x.event_name}</option>
                                                        )
                                                    })}
                                                </select>
                                            </div>
                                        </div>}
                                </div>
                            </div>
                        </div>

                        {triggerEvent &&
                            <div className="d-flex justify-content-center my-4">
                                <div style={{ width: "100%", maxWidth: "700px" }}>
                                    {/* Label outside the card but left-aligned with card content */}
                                    <span className="text-muted fw-semibold mb-2 d-block">
                                        <b>CREATE CONTACT LIST</b>
                                    </span>

                                    {/* Card content */}
                                    <div className="card" style={{
                                        backgroundColor: "white",
                                        padding: "1.5rem"
                                    }}>
                                        {/* <p>Select the fields from the response you want to save to your contact list.</p> */}

                                        <div className="mb-3">
                                            <label className="form-label">
                                                <b>Contact List Name</b>
                                            </label>

                                            <div className="row g-2">
                                                {/* Input — col-8 */}
                                                <div className="col-8">
                                                    <select className='form-control' value={contactList} onChange={handleContactListChange}>
                                                        <option>Select Contact List</option>
                                                        {contactListData.map((item) => {
                                                            return (
                                                                <option value={item.id}>{item.name}</option>
                                                            )
                                                        })}
                                                    </select>
                                                </div>

                                                {/* Save Button — col-4, aligned right */}
                                                <div className="col-4 d-flex justify-content-end">
                                                    <button onClick={NewContactList} className="btn btn-info w-100">
                                                        Add New
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>}

                        {(showgenerateUrl || id) &&
                            <div className="d-flex justify-content-center my-4">
                                <div style={{ width: "100%", maxWidth: "700px" }}>
                                    {/* Label outside the card but left-aligned with card content */}
                                    <span className="text-muted fw-semibold mb-2 d-block">
                                        <b>GENERATE WEBHOOK</b>
                                    </span>

                                    {/* Card content */}
                                    <div
                                        className="card"
                                        style={{
                                            backgroundColor: "white",
                                            padding: "1.5rem"
                                        }}
                                    >
                                        <div className="row">
                                            <div className="col-12">
                                                {/* <span style={{ fontSize: "13px" }}>To map your data, you first need to capture a sample response from your trigger app.</span> */}
                                                {!id && <button type="button" onClick={GenerateUrl} class="btn btn-info form-control mt-2">Generate URL</button>}
                                                {(showUrl || id) &&
                                                    <>
                                                        <p>
                                                            Copy the URL below and paste it into your application's webhook settings.
                                                            Then, trigger the event in your application to send a sample request to this URL.
                                                        </p>

                                                        <div className="input-group mb-3">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={webhookURL}
                                                                readOnly
                                                            />
                                                            <button className="btn btn-outline-secondary" onClick={copyToClipboard}>
                                                                📋
                                                            </button>
                                                        </div>
                                                        {!id && <button type="button" onClick={CaptureResponse} class="btn btn-info form-control mt-2">Capture Response</button>}
                                                    </>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                        

                        {showNextstep &&
                            <>
                                <div className="d-flex justify-content-center my-4">
                                    <div style={{ width: "100%", maxWidth: "700px" }}>
                                        {/* Label outside the card but left-aligned with card content */}
                                        <span className="text-muted fw-semibold mb-2 d-block">
                                            <b>RESPONSE DATA</b>
                                        </span>

                                        {/* Card content */}
                                        <div className="card" style={{
                                            backgroundColor: "white",
                                            padding: "1.5rem"
                                        }}>
                                            <p>Select the fields from the response you want to save to your contact list.</p>

                                            <div
                                                className="form-check overflow-auto border rounded p-3"
                                                style={{ maxHeight: '200px' }}
                                            >
                                                {allKeys.map((field) => (
                                                    <div key={field} className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            id={field}
                                                            checked={selectedFields.includes(field)}
                                                            onChange={() => handleCheckboxChange(field)}
                                                        />
                                                        <label className="form-check-label" htmlFor={field}>
                                                            {field}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>

                                            <p className='mt-2'>Selected Fields</p>
                                            <textarea className='form-control' value={selectedFields.map(x => x + " ")} />

                                            {selectedFields.length > 0 &&
                                                <>
                                                    <div className='row mt-2'>
                                                        <div className='col-6'>
                                                            <p><b>Mobile:</b></p>
                                                        </div>
                                                        <div className='col-6'>
                                                            <select className='form-control' name='mobile' value={fields.mobile} onChange={handleFieldChange}>
                                                                <option value="">Selected Field</option>
                                                                {selectedFields.map((x) => {
                                                                    return (
                                                                        <option value={x}>{x}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className='row mt-2'>
                                                        <div className='col-6'>
                                                            <p><b>Email:</b></p>
                                                        </div>
                                                        <div className='col-6'>
                                                            <select className='form-control' name='email' value={fields.email} onChange={handleFieldChange}>
                                                                <option value="">Selected Field</option>
                                                                {selectedFields.map((x) => {
                                                                    return (
                                                                        <option value={x}>{x}</option>
                                                                    )
                                                                })}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </>}
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-center my-4">
                                    <div style={{ width: "100%", maxWidth: "700px" }}>
                                        <div className="d-flex align-items-center gap-2">
                                            {/* Label */}
                                            <span className="text-muted fw-semibold">
                                                <b>Want to Trigger an event</b>
                                            </span>

                                            {/* Toggle */}
                                            <div className="form-check form-switch m-0">
                                                <label className="switch">
                                                    <input
                                                        type="checkbox"
                                                        checked={triggerEventAction}
                                                        onChange={(e) => setTriggerEventAction(e.target.checked)}
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                                {/* <input
                                                            className="form-check-input ml-2"
                                                            type="checkbox"
                                                            id="triggerToggle"
                                                            checked={triggerEventAction}
                                                            onChange={(e) => setTriggerEventAction(e.target.checked)}
                                                        /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                {/* <div className="d-flex justify-content-center gap-2 my-3">
                                            <span className="text-muted fw-semibold mb-2 d-block">
                                                <b>Want to Trigger an event</b>
                                            </span>

                                            <div className="form-check form-switch m-0">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="triggerToggle"
                                                    checked={triggerEvent}
                                                    onChange={(e) => setTriggerEvent(e.target.checked)}
                                                />
                                            </div>
                                        </div> */}


                                {triggerEventAction &&
                                    <div className="d-flex justify-content-center my-4">
                                        <div style={{ width: "100%", maxWidth: "700px" }}>
                                            {/* Label outside the card but left-aligned with card content */}
                                            <span className="text-muted fw-semibold mb-2 d-block">
                                                <b>ACTION: THEN DO THIS...</b>
                                            </span>

                                            {/* Card content */}
                                            <div
                                                className="card"
                                                style={{
                                                    backgroundColor: "white",
                                                    padding: "1.5rem"
                                                }}
                                            >
                                                <div className="row">
                                                    <div className="col-12">
                                                        <label><b>Select Channel</b></label>
                                                        <Select
                                                            options={channelOptions}
                                                            isMulti
                                                            closeMenuOnSelect={false}
                                                            hideSelectedOptions={false}
                                                            classNamePrefix="select"
                                                            placeholder="Select Channel"
                                                            onChange={channelHandler}
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                {channel && (
                                                    <>
                                                        {/* WHATSAPP */}
                                                        {channel.some(x => x.value === "whatsapp") && (
                                                            <div className="row mt-2">
                                                                <div className="col-12">
                                                                    <label><b>Select Template Whatsapp</b></label>
                                                                    <select
                                                                        className="form-control"
                                                                        value={String(whatsapptemplateSelect?.id) || ""}
                                                                        onChange={handleWhatsappTemplateChange}
                                                                    >
                                                                        <option value="">--Choose a Template--</option>
                                                                        {whatsappTemplateList.map(x => (
                                                                            <option key={x.id ?? x._id} value={x.id ?? x._id}>
                                                                                {x.temp_name || x.template_name}
                                                                            </option>
                                                                        ))}
                                                                    </select>

                                                                </div>
                                                            </div>
                                                        )}

                                                        {whatsapptemplateSelect &&
                                                            <>
                                                                <div className="row mt-2">
                                                                    <div className="col-12">
                                                                        <span><b>Map Template whatsapp Variable</b></span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mt-2">
                                                                    <div className="col-12">
                                                                        <span style={{ fontSize: "13px" }}>{whatsapptemplateSelect.temp_body || whatsapptemplateSelect.content}</span>
                                                                    </div>
                                                                </div>
                                                                {whatsappVariable && Object.keys(whatsappVariable).map((key) => {
                                                                    return (
                                                                        <div className="row mt-2" key={key}>
                                                                            <div className="col-6">
                                                                                <span><b>{`{{${parseInt(key) + 1}}}`}</b></span>
                                                                            </div>

                                                                            <div className="col-6">
                                                                                <select
                                                                                    className="form-control"
                                                                                    value={selectedWhatsappvariable[parseInt(key) + 1] || ""}
                                                                                    onChange={(e) => handleWhatsappVariableChange(parseInt(key) + 1, e.target.value)}
                                                                                >
                                                                                    <option value="">--Select data source--</option>
                                                                                    {selectedFields.map((field) => (
                                                                                        <option key={field} value={field}>
                                                                                            {field}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}

                                                                {/* <span style={{fontSize:"13px"}}></span> */}
                                                            </>}

                                                        {/* SMS */}
                                                        {channel.some(x => x.value === "sms") && (
                                                            <div className="row mt-2">
                                                                <div className="col-12">
                                                                    <label><b>Select Template SMS</b></label>
                                                                    <select
                                                                        className="form-control"
                                                                        value={String(smstemplateSelect?.id) || ""}
                                                                        onChange={handleSmsTemplateChange}
                                                                    >
                                                                        <option value="">--Choose a Template--</option>
                                                                        {smsTemplateList.map(x => (
                                                                            <option key={x.id} value={x.id}>
                                                                                {x.template_name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {smstemplateSelect &&
                                                            <>
                                                                <div className="row mt-2">
                                                                    <div className="col-12">
                                                                        <span><b>Map Template SMS Variable</b></span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mt-2">
                                                                    <div className="col-12">
                                                                        <span style={{ fontSize: "13px" }}>{smstemplateSelect.content}</span>
                                                                    </div>
                                                                </div>

                                                                {smsVariable && Object.keys(smsVariable).map((key) => {
                                                                    return (
                                                                        <div className="row mt-2" key={key}>
                                                                            <div className="col-6">
                                                                                <span><b>{`{{${parseInt(key) + 1}}}`}</b></span>
                                                                            </div>

                                                                            <div className="col-6">
                                                                                <select
                                                                                    className="form-control"
                                                                                    value={selectedSmsvariable[parseInt(key) + 1] || ""}
                                                                                    onChange={(e) => handleSmsVariableChange(parseInt(key) + 1, e.target.value)}
                                                                                >
                                                                                    <option value="">--Select data source--</option>
                                                                                    {selectedFields.map((field) => (
                                                                                        <option key={field} value={field}>
                                                                                            {field}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                                {/* <span style={{fontSize:"13px"}}></span> */}
                                                            </>}

                                                        {/* RCS */}
                                                        {channel.some(x => x.value === "rcs") && (
                                                            <div className="row mt-2">
                                                                <div className="col-12">
                                                                    <label><b>Select Template RCS</b></label>
                                                                    <select
                                                                        className="form-control"
                                                                        value={String(rcstemplateSelect?._id) || ""}
                                                                        onChange={handleRcsTemplateChange}
                                                                    >
                                                                        <option value="">--Choose a Template--</option>
                                                                        {rcsTemplateList.map(x => (
                                                                            <option key={x._id} value={x._id}>
                                                                                {x.temp_name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {rcstemplateSelect &&
                                                            <>
                                                                <div className="row mt-2">
                                                                    <div className="col-12">
                                                                        <span><b>Map Template RCS Variable</b></span>
                                                                    </div>
                                                                </div>
                                                                <div className="row mt-2">
                                                                    <div className="col-12">
                                                                        <span style={{ fontSize: "13px" }}>{rcstemplateSelect.temp_body}</span>
                                                                    </div>
                                                                </div>
                                                                {rcsVariable && Object.keys(rcsVariable).map((key) => {
                                                                    return (
                                                                        <div className="row mt-2" key={key}>
                                                                            <div className="col-6">
                                                                                <span><b>{`[${key}]`}</b></span>
                                                                            </div>

                                                                            <div className="col-6">
                                                                                <select
                                                                                    className="form-control"
                                                                                    value={selectedRcsvariable?.[key] || ""}
                                                                                    onChange={(e) =>
                                                                                        handleRcsVariableChange(key, e.target.value)
                                                                                    }
                                                                                >
                                                                                    <option value="">--Select data source--</option>
                                                                                    {selectedFields?.map((field) => (
                                                                                        <option key={field} value={field}>
                                                                                            {field}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}

                                                                {/* <span style={{fontSize:"13px"}}></span> */}
                                                            </>}

                                                        {/* VOICE */}
                                                        {channel.some(x => x.value === "voice") && (
                                                            <div className="row mt-2">
                                                                <div className="col-12">
                                                                    <label><b>Select Template Voice</b></label>
                                                                    <select
                                                                        className="form-control"
                                                                        value={String(voicetemplateSelect?.id) || ""}
                                                                        onChange={handleVoiceTemplateChange}
                                                                    >
                                                                        <option value="">--Choose a Template--</option>
                                                                        {voiceTemplateList.map(x => (
                                                                            <option key={x.id} value={x.id}>
                                                                                {x.template_name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                                {/* <hr /> */}

                                            </div>
                                        </div>
                                    </div>}
                                <div className="d-flex justify-content-center my-4">
                                    <div className="d-flex justify-content-end gap-2" style={{ maxWidth: "700px", width: "100%" }}>
                                        <button type="button" className="btn btn-secondary">Cancel</button>
                                        <button type="button" onClick={SaveWebhook} disabled={disableButton ? true : false} className="btn btn-info">Save</button>
                                    </div>
                                </div>
                            </>}








                    </div>
                </main>

                <DashboardFooter />
            </div>
        </div>
    )
}

export default Workflow
